import {
  CLEAR_TEST_HISTORY,
  FETCH_TEST_HISTORY_FAILED,
  FETCH_TEST_HISTORY_LOADING,
  FETCH_TEST_HISTORY_SILENT_LOADING,
  FETCH_TEST_HISTORY_SUCCESS
} from "../actionTypeConstants/lambdaTestHistoryConstants";

import cloneDeep from "lodash/cloneDeep";
import isEmpty from "lodash/isEmpty";

const initialState = {
  testHistory: {
    isLoading: false,
    isSilentLoading: false,
    data: [],
    error: null
  }
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_TEST_HISTORY_LOADING: {
      return {
        ...state,
        testHistory: {
          ...state.testHistory,
          isSilentLoading: false,
          isLoading: true
        }
      };
    }

    case FETCH_TEST_HISTORY_SILENT_LOADING: {
      return {
        ...state,
        testHistory: {
          ...state.testHistory,
          isSilentLoading: true,
          isLoading: false
        }
      };
    }

    case FETCH_TEST_HISTORY_SUCCESS: {
      let newData = cloneDeep(state.testHistory.data);

      if (isEmpty(newData)) {
        newData = cloneDeep(action?.result?.data);
      } else {
        newData = {
          ...newData,
          data: [...newData.data, ...(action?.result?.data?.data || [])]
        };
      }

      return {
        ...state,
        testHistory: {
          ...state.testHistory,
          isLoading: false,
          isSilentLoading: false,
          data: newData
        }
      };
    }

    case FETCH_TEST_HISTORY_FAILED: {
      return {
        ...state,
        testHistory: {
          ...state.testHistory,
          isLoading: false,
          isSilentLoading: false,
          error: action.error
        }
      };
    }

    case CLEAR_TEST_HISTORY: {
      return {
        ...state,
        testHistory: {
          isLoading: false,
          isSilentLoading: false,
          data: [],
          error: null
        }
      };
    }

    default:
      return state;
  }
}
